import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site-data";

export default function Services() {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 blueprint-grid opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        {/* Heading */}
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="block w-8 h-px bg-[#385723]" />
              <span className="overline">02 · Servicios</span>
            </div>
            <h2 className="heading-lg text-3xl sm:text-4xl lg:text-5xl text-white">
              Cinco pilares,
              <br />
              <span className="text-[#385723]">un solo proyecto.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 flex items-end">
            <p className="font-body text-base lg:text-lg text-white/70 leading-relaxed">
              Desde el cálculo estructural hasta el último acabado de lujo, ejecutamos cada etapa
              con metodología propia y supervisión técnica continua. Una sola firma responsable de
              tu obra de principio a fin.
            </p>
          </div>
        </div>

        {/* Services grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {SERVICES.map((service, idx) => (
            <article
              key={idx}
              data-testid={`service-card-${idx}`}
              className={`service-card relative bg-luxe-black overflow-hidden group cursor-pointer ${
                idx === 0 ? "lg:col-span-2 lg:row-span-1" : ""
              }`}
            >
              {/* Image background */}
              <div className="relative aspect-[4/3] lg:aspect-[3/2] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="service-card-img w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                {/* Number */}
                <span className="absolute top-6 left-6 font-heading text-xs tracking-[0.3em] text-[#385723] font-semibold uppercase">
                  {service.num}
                </span>
                <span className="absolute top-6 right-6 w-10 h-10 border border-white/20 flex items-center justify-center group-hover:border-[#385723] group-hover:bg-[#385723] transition-all">
                  <ArrowUpRight className="w-4 h-4 text-white" />
                </span>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="flex items-center gap-3 mb-3">
                  <service.Icon className="w-5 h-5 text-[#006961]" strokeWidth={1.5} />
                  <span className="block w-8 h-px bg-[#006961]/40" />
                </div>
                <h3 className="heading-md text-xl lg:text-2xl text-white mb-3 group-hover:text-[#385723] transition-colors">
                  {service.title}
                </h3>
                <p className="font-body text-sm text-white/60 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
